import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-new-accessory-practice',
  templateUrl: './dialog-new-accessory-practice.component.html',
})
export class DialogNewAccessoryPracticeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
